import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/css/main.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './lib/InstallPromptManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The service worker activates and claims open tabs on its own
// (self.skipWaiting() + clientsClaim() in service-worker.js) and navigation
// is served network-first, so every fresh app open already gets the latest
// deploy without needing a forced reload here.
serviceWorkerRegistration.register();